<div class="payment-settings">
  <app-collapsible-card
    class="payment-settings__card"
    title="Stripe Connect"
    [isCollapsed]="false"
    [isFixedOpen]="true"
  >
    <p class="payment-settings__lead">
      Choose which <strong>Stripe connected account</strong> and <strong>location</strong> to use
      for payments. Listing accounts uses your <strong>backend API</strong> (the Stripe secret key
      must never be shipped to the browser). Client-side Stripe.js uses your
      <strong>publishable key</strong> from environment when you take card payments elsewhere in the
      app.
    </p>

    <p class="payment-settings__meta" *ngIf="hasPublishableKey">
      Publishable key is configured for this build (used by Stripe.js; not for listing Connect
      accounts).
    </p>
    <p class="payment-settings__meta payment-settings__meta--warn" *ngIf="!hasPublishableKey">
      No <code>stripePublicKey</code> in environment — add it for Stripe.js card flows.
    </p>

    <p class="payment-settings__hint" *ngIf="accountsSource === 'none' && !loadingAccounts">
      No connected accounts were returned from the API, and your locations do not include
      <code>stripe_account_id</code>. Implement <code>GET …/stripe/connect/accounts</code> on the
      server (using the Stripe secret key from your server env), or attach
      <code>stripe_account_id</code> to each location in the API response.
    </p>

    <p class="payment-settings__hint" *ngIf="accountsSource === 'locations' && accounts.length">
      Showing accounts inferred from your locations’ <code>stripe_account_id</code>. For full
      account metadata, add the Connect list endpoint on the server.
    </p>

    <div class="payment-settings__fields" *ngIf="accounts.length || loadingAccounts">
      <label class="payment-settings__label" for="stripe-connect-account">Connected account</label>
      <div class="payment-settings__dropdown-wrap select-wrapper">
        <mat-select
          id="stripe-connect-account"
          class="form-select"
          [ngModel]="selectedAccountId"
          (ngModelChange)="onAccountSelected($event)"
          placeholder="Select account…"
          [disabled]="loadingAccounts || !accountOptions.length"
        >
          <app-select-search #accountOptionsSearch placeholder="Search"></app-select-search>
          <mat-option
            *ngFor="
              let account of accountOptions
                | selectFilter: accountOptionsSearch.query : ['label', 'id']
            "
            [value]="account.id"
          >
            <span class="payment-settings__option-text">{{ account.label }}</span>
          </mat-option>
        </mat-select>
      </div>
      <span class="payment-settings__spinner" *ngIf="loadingAccounts">Loading…</span>
    </div>

    <!-- Show once accounts exist (don't wait on selectedAccountId — mat-select can clear it). -->
    <div class="payment-settings__fields" *ngIf="accounts.length > 0">
      <label class="payment-settings__label" for="stripe-connect-location">Location</label>
      <div class="payment-settings__dropdown-wrap select-wrapper">
        <mat-select
          id="stripe-connect-location"
          class="form-select"
          [ngModel]="selectedLocationId"
          (ngModelChange)="onLocationSelected($event)"
          [placeholder]="locationSelectPlaceholder"
          [disabled]="!selectedAccountId || loadingLocations"
        >
          <app-select-search #locationOptionsSearch placeholder="Search"></app-select-search>
          <mat-option *ngIf="!loadingLocations && locationOptions.length === 0" disabled>
            <span class="payment-settings__option-text payment-settings__option-text--muted">
              No Stripe Terminal location (tml_…) found for this account. Create or link one under
              Terminal Settings.
            </span>
          </mat-option>
          <mat-option
            *ngFor="
              let location of locationOptions
                | selectFilter: locationOptionsSearch.query : ['label', 'id']
            "
            [value]="location.id"
          >
            <span class="payment-settings__option-text">{{ location.label }}</span>
          </mat-option>
        </mat-select>
      </div>
      <span class="payment-settings__spinner" *ngIf="loadingLocations">Loading…</span>
    </div>

    <div class="payment-settings__actions" *ngIf="accounts.length">
      <button
        type="button"
        class="btn btn-primary btn-medium"
        [disabled]="!canSavePaymentSettings"
        (click)="save()"
      >
        Save preference
      </button>
    </div>

    <p
      class="payment-settings__message payment-settings__message--ok"
      *ngIf="saveMessage?.type === 'ok'"
    >
      {{ saveMessage?.text }}
    </p>
    <p
      class="payment-settings__message payment-settings__message--err"
      *ngIf="saveMessage?.type === 'err'"
    >
      {{ saveMessage?.text }}
    </p>
  </app-collapsible-card>
</div>
